function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCollection = function SvgAddCollection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.63 21.25"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 .37H3.5a.59.59 0 0 0-.62.63v17.5a.58.58 0 0 0 .62.62H21a.58.58 0 0 0 .62-.62V1A.59.59 0 0 0 21 .37m-1.38 17.5H4.88a.81.81 0 0 1-.76-.75V2.37a.82.82 0 0 1 .76-.75h14.87a.81.81 0 0 1 .75.75v14.88a1.15 1.15 0 0 1-.88.62m-1.12 2.5a.63.63 0 0 1 0 1.25H1A.58.58 0 0 1 .38 21V3.5A.59.59 0 0 1 1 2.87a.59.59 0 0 1 .62.63v16.12a.81.81 0 0 0 .76.75Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-.38 -.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.63,
    cy: 10.63,
    r: 10,
    style: {
      fill: "#06d1bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      isolation: "isolate",
      fontSize: 12,
      fill: "#fff",
      fontFamily: "OpenSans-Bold,Open Sans",
      fontWeight: 700
    },
    transform: "translate(19.2 14.63)"
  }, "+")));
};
export default SvgAddCollection;